// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + {"142":"fileset","894":"select2"}[chunkId] + "." + {"142":"e6d7b053f53355b2bc8d","894":"f56c8f19159376309ae2"}[chunkId] + ".css";
};